<template>
  <div>
    <h1 class="h3 title-manage-account">
      <router-link
          :to="{ name: 'dashboard-company-list' }">
        Empresas
      </router-link>
      <span
          v-if="company"
          class="breadcrumbs-arrow">{{ company.name }}</span>
      <span
          v-else
          class="breadcrumbs-arrow">Nova empresa</span>
    </h1>

    <!-- ALERT -->
    <alert-helper
        :alert="alert.default.message"
        :type="alert.default.type"
        :close="true"
        class="_mt-10"/>
    <!-- // ALERT -->

    <div class="company-single-form row">
      <admin-company
          :loading="loading"
          :company="company"
          @handleSubmit="handleUpdate"
          @handleCompany="handleAdminCompany"/>

      <file-upload
          v-if="company"
          :key="company.logo"
          :file="company.logo"
          :name="'logo'"
          :label="'Logotipo'"
          :loading="loading"
          @handleSubmit="handleUpload"
          class="company-single-form-upload"/>
    </div>

    <!-- ALERT -->
    <alert-helper
        :alert="alert.actions.message"
        :type="alert.actions.type"
        :close="true"
        class="_mt-10"/>
    <!-- // ALERT -->

    <template v-if="company">
      <div class="row">
        <div class="col-sm-4">
          <company-limit
              :limit="company.month_limit"
              :loading="loading"
              @handleAction="handleActionUpdate"></company-limit>
        </div>
        <div class="col-sm-4">
          <company-limit-per-user
              :limit="company.daily_limit_per_user"
              :loading="loading"
              @handleAction="handleActionUpdate"></company-limit-per-user>
        </div>
        <div class="col-sm-4">
          <!-- is_active | Bloqueio -->
          <action-confirmation
              title="Bloqueio"
              button-label="Bloquear Empresa"
              description="Tem certeza que deseja bloquear o cliente?"
              color="magenta"
              action="postAdminCompanyBlock"
              @handleAction="handleActionUpdate"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <update-fee
              :company_id="company.id"
              @handleAction="handleActionUpdate"></update-fee>
        </div>

        <div class="col-sm-4">
          <update-cashback
              :cashback="company.cashback"
              :loading="loading"
              @handleAction="handleActionUpdate"></update-cashback>

          <handle-client
              :company_id="company.id"
              @handleAction="handleActionUpdate"></handle-client>
        </div>
        <div class="col-sm-4">
          <!-- is_business_partner | Tornar representante comercial -->
          <action-confirmation
              title="Representante Comercial"
              button-label="Tornar representante Comercial"
              description="Tem certeza que deseja tornar a empresa um representante comercial?"
              color="green"
              action="postAdminCompanyUpdateRepresentative"
              @handleAction="handleActionUpdate"/>
        </div>
      </div>
    </template>

    <!-- /Modelo de página -->
    <lock-screen :loading="loading"/>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import AdminCompany from '@/views/dashboard/company/single/AdminCompany'
import CompanyLimit from '@/views/dashboard/company/single/CompanyLimit'
import CompanyLimitPerUser from '@/views/dashboard/company/single/CompanyLimitPerUser'
import UpdateFee from '@/views/dashboard/company/single/UpdateFee'
import ActionConfirmation from '@/views/dashboard/company/single/ActionConfirmation'
import UpdateCashback from '@/views/dashboard/company/single/UpdateCashback'
import AlertHelper from '@/components/ui/AlertHelper'
import FileUpload from '@/components/forms/FileUpload'
import LockScreen from '@/components/lockscreen/index.vue'
import { companyAssigned } from '@/models/Company'
import HandleClient from '@/views/dashboard/company/single/HandleClient.vue'

export default {
  components: {
    AdminCompany,
    CompanyLimit,
    CompanyLimitPerUser,
    ActionConfirmation,
    UpdateCashback,
    AlertHelper,
    FileUpload,
    LockScreen,
    UpdateFee,
    HandleClient
  },
  data() {
    return {
      company: null,
      alert: {
        default: {
          message: false,
          type: 'success'
        },
        actions: {
          message: false,
          type: 'success'
        }
      }
    }
  },
  mounted() {
    this.handleAdminCompany()
  },
  computed: {
    ...mapState('companies', ['loading'])
  },
  methods: {
    ...mapActions('companies', [
      'getAdminCompany',
      'postAdminCompanyUpdate',
      'postAdminCompanyUpdateLogo',
      'postAdminCompanyUpdateLimit',
      'postAdminCompanyUpdateDailyLimitPerUser',
      'postAdminCompanyBlock',
      'postAdminCompanyUpdateRepresentative',
      'postAdminCompanyUpdateCashback'
    ]),
    handleAdminCompany(id = null) {
      const documentNumber = id || this.$route.params.documentNumber
      if (documentNumber) {
        this.getAdminCompany(documentNumber)
            .then(response => {
              const company = companyAssigned(response)
              this.company = {...company}
            })
            .catch(error => {
              this.handleMessage(error, 'danger')
            })
      }
    },
    handleUpload(form) {
      this.alert.default.message = false
      form.set('company_id', this.company.id)

      this.postAdminCompanyUpdateLogo(form)
          .then(message => {
            this.handleMessage(message, 'success')
            this.handleAdminCompany(this.company.document_number)
          })
          .catch(error => {
            this.handleMessage(error, 'danger')
          })
    },
    handleUpdate(form) {
      this.alert.default.message = false

      this.postAdminCompanyUpdate(form)
          .then(message => {
            this.handleMessage(message, 'success')
            this.handleAdminCompany(this.company.document_number)
          })
          .catch(error => {
            this.handleMessage(error, 'danger')
          })
    },
    handleActionUpdate(action, form) {
      this.alert.actions.message = false

      this[action]({...form, company_id: this.company.id})
          .then(message => {
            this.handleMessage(message, 'success', 'actions')
            this.handleAdminCompany(this.company.document_number)
          })
          .catch(error => {
            this.handleMessage(error, 'danger', 'actions')
          })
    },
    handleMessage(message, type, alert = 'default') {
      this.alert[alert].message = message
      this.alert[alert].type = type
    }
  }
}
</script>

<style scoped lang="scss">
.company-single-form {
  position: relative;
  padding: 0 0 40px 0;
  @include breakpoint($sm-device-min) {

  }
}

.company-single-form-upload {
  @include breakpoint($md-device-min) {
    margin-top: 0;
    position: absolute;
    bottom: 35px;
    left: 0;
    right: 50%;
    z-index: 1;
  }
}
</style>
